"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundAspectRatio = exports.aspectRatioSchemaFieldDescription = exports.aspectRatios = exports.RATIOS = void 0;
var image_1 = require("./image");
var RATIOS = {
    RATIO_1_1: '1:1',
    RATIO_2_1: '2:1',
    RATIO_2_3: '2:3',
    RATIO_3_2: '3:2',
    RATIO_4_1: '4:1',
    RATIO_4_3: '4:3',
    RATIO_5_2: '5:2',
    RATIO_5_3: '5:3',
    RATIO_5_4: '5:4',
    RATIO_5_6: '5:6',
    RATIO_5_7: '5:7',
    RATIO_5_9: '5:9',
    RATIO_6_5: '6:5',
    RATIO_7_2: '7:2',
    RATIO_7_3: '7:3',
    RATIO_7_5: '7:5',
    RATIO_8_9: '8:9',
    RATIO_10_9: '10:9',
    RATIO_14_5: '14:5',
    RATIO_15_8: '15:8',
    RATIO_16_9: '16:9',
    RATIO_17_8: '17:8',
};
exports.RATIOS = RATIOS;
var roundAspectRatio = function (aspectRatio) {
    return Number(Number.parseFloat(aspectRatio.toString()).toFixed(2));
};
exports.roundAspectRatio = roundAspectRatio;
var aspectRatios = (_a = {},
    _a[RATIOS.RATIO_1_1] = {
        ratio: roundAspectRatio(1 / 1),
        label: RATIOS.RATIO_1_1,
    },
    _a[RATIOS.RATIO_2_1] = {
        ratio: roundAspectRatio(2 / 1),
        label: RATIOS.RATIO_2_1,
    },
    _a[RATIOS.RATIO_2_3] = {
        ratio: roundAspectRatio(2 / 3),
        label: RATIOS.RATIO_2_3,
    },
    _a[RATIOS.RATIO_3_2] = {
        ratio: roundAspectRatio(3 / 2),
        label: RATIOS.RATIO_3_2,
    },
    _a[RATIOS.RATIO_4_1] = {
        ratio: roundAspectRatio(4 / 1),
        label: RATIOS.RATIO_4_1,
    },
    _a[RATIOS.RATIO_4_3] = {
        ratio: roundAspectRatio(4 / 3),
        label: RATIOS.RATIO_4_3,
    },
    _a[RATIOS.RATIO_5_2] = {
        ratio: roundAspectRatio(5 / 2),
        label: RATIOS.RATIO_5_2,
    },
    _a[RATIOS.RATIO_5_3] = {
        ratio: roundAspectRatio(5 / 3),
        label: RATIOS.RATIO_5_3,
    },
    _a[RATIOS.RATIO_5_4] = {
        ratio: roundAspectRatio(5 / 4),
        label: RATIOS.RATIO_5_4,
    },
    _a[RATIOS.RATIO_5_6] = {
        ratio: roundAspectRatio(5 / 6),
        label: RATIOS.RATIO_5_6,
    },
    _a[RATIOS.RATIO_5_7] = {
        ratio: roundAspectRatio(5 / 7),
        label: RATIOS.RATIO_5_7,
    },
    _a[RATIOS.RATIO_5_9] = {
        ratio: roundAspectRatio(5 / 9),
        label: RATIOS.RATIO_5_9,
    },
    _a[RATIOS.RATIO_6_5] = {
        ratio: roundAspectRatio(6 / 5),
        label: RATIOS.RATIO_6_5,
    },
    _a[RATIOS.RATIO_7_2] = {
        ratio: roundAspectRatio(7 / 2),
        label: RATIOS.RATIO_7_2,
    },
    _a[RATIOS.RATIO_7_3] = {
        ratio: roundAspectRatio(7 / 3),
        label: RATIOS.RATIO_7_3,
    },
    _a[RATIOS.RATIO_7_5] = {
        ratio: roundAspectRatio(7 / 5),
        label: RATIOS.RATIO_7_5,
    },
    _a[RATIOS.RATIO_8_9] = {
        ratio: roundAspectRatio(8 / 9),
        label: RATIOS.RATIO_8_9,
    },
    _a[RATIOS.RATIO_10_9] = {
        ratio: roundAspectRatio(10 / 9),
        label: RATIOS.RATIO_10_9,
    },
    _a[RATIOS.RATIO_14_5] = {
        ratio: roundAspectRatio(14 / 5),
        label: RATIOS.RATIO_14_5,
    },
    _a[RATIOS.RATIO_15_8] = {
        ratio: roundAspectRatio(15 / 8),
        label: RATIOS.RATIO_15_8,
    },
    _a[RATIOS.RATIO_16_9] = {
        ratio: roundAspectRatio(16 / 9),
        label: RATIOS.RATIO_16_9,
    },
    _a[RATIOS.RATIO_17_8] = {
        ratio: roundAspectRatio(17 / 8),
        label: RATIOS.RATIO_17_8,
    },
    _a);
exports.aspectRatios = aspectRatios;
var aspectRatioSchemaFieldDescription = function (ratio) {
    return "".concat(image_1.imageDescription, ". Only upload media with an aspect ratio of ").concat(aspectRatios[ratio].label, ".");
};
exports.aspectRatioSchemaFieldDescription = aspectRatioSchemaFieldDescription;
